import { Box, Button, Container } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import sidraLogo from '../../assets/logo.png';
import { topBarStyles } from './eventDetailsStyles';

const EventTopBar = ({ onBack }) => (
  <Container maxWidth="lg" sx={topBarStyles.content}>
    <Box component="img" src={sidraLogo} alt="Sidra Medicine" sx={topBarStyles.logo} />
    {onBack && <Button startIcon={<ArrowBackIcon />} onClick={onBack}>Back to Events</Button>}
  </Container>
);

export default EventTopBar;
